// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#meta-component .ant-table .ant-table-tbody tr td {\n  vertical-align: middle;\n}\n\n#meta-component .divider {\n  border: none;\n  border-top: 1px solid #ededed;\n}\n\n#meta-component .ql-editor {\n  height: 250px !important;\n}\n\n#meta-component-drawer\n  .photo-uploader\n  .ant-upload.ant-upload-select-picture-card {\n  width: 100%;\n  height: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
